/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_SUF_PERCEPTIONS_ITEM = {
  id: 'suffered_perceptions',
  screenId: 'tax-suf-perceptions',
  label: 'Percepciones',
  description: 'Percepciones en facturas de compra de proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Listado de percepciones que te facturaron tus proveedores: líneas de compra cuyo artículo tiene un impuesto de percepción asignado.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Impuesto', description: 'Todos o uno concreto.' },
          { label: 'Desde / Hasta', description: 'Fecha contable de la factura de compra.' },
        ],
        paragraphs: [
          'Tocá «Buscar». Si no hay resultados, revisá que los artículos tengan impuesto en Administración → Productos y que existan facturas de compra en el período.',
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: Fecha cont., Comprobante, Proveedor, Impuesto, Artículo, Importe, Moneda.',
          'Solo consulta; exportable.',
        ],
      },
    ],
  },
}
